module.exports = __webpack_public_path__ + "static/media/explos.a3ae7f5d.svg";